// extracted by mini-css-extract-plugin
export default {"wrapper":"MonitorAccount_wrapper__C39h4","form_box":"MonitorAccount_form_box__89B6z","btnBlank":"MonitorAccount_btnBlank__Agj0m"};